import { render, staticRenderFns } from "./OrderTransport.vue?vue&type=template&id=2f132627&scoped=true"
import script from "./OrderTransport.vue?vue&type=script&lang=js"
export * from "./OrderTransport.vue?vue&type=script&lang=js"
import style0 from "./OrderTransport.vue?vue&type=style&index=0&id=2f132627&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f132627",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f132627')) {
      api.createRecord('2f132627', component.options)
    } else {
      api.reload('2f132627', component.options)
    }
    module.hot.accept("./OrderTransport.vue?vue&type=template&id=2f132627&scoped=true", function () {
      api.rerender('2f132627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver/components/OrderTransport.vue"
export default component.exports